module.exports = __webpack_public_path__ + "img/cuw.f1b3043c.svg";